"use client";

import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export function TerminalBootSequence({ 
  lines, 
  promptColor = "text-success",
  className
}: { 
  lines: string[], 
  promptColor?: string,
  className?: string 
}) {
  const [visibleLines, setVisibleLines] = useState<number>(0);

  useEffect(() => {
    if (visibleLines < lines.length) {
      const timeout = setTimeout(() => {
        setVisibleLines(v => v + 1);
      }, Math.random() * 400 + 150); // Random typing speed
      return () => clearTimeout(timeout);
    }
  }, [visibleLines, lines.length]);

  return (
    <div className={cn("flex flex-col p-2 font-mono text-[13px] text-text-tertiary opacity-80", className)}>
      {lines.slice(0, visibleLines).map((line, i) => (
        <motion.p 
          key={i} 
          initial={{ opacity: 0, filter: "blur(4px)", x: -5 }} 
          animate={{ opacity: 1, filter: "blur(0px)", x: 0 }} 
          transition={{ duration: 0.2 }}
          className="flex items-start gap-2 mb-1.5"
        >
          <span className="text-text-secondary mt-0.5">{i === 0 ? "~" : ">"}</span> 
          <span className="phosphor leading-relaxed">{line}</span>
        </motion.p>
      ))}
      {visibleLines === lines.length && (
        <motion.p 
          initial={{ opacity: 0 }} 
          animate={{ opacity: 1 }} 
          transition={{ delay: 0.2 }}
          className="flex items-center gap-2 mt-3"
        >
          <span className={cn("font-bold text-lg", promptColor)}>{'>'}</span>
          <span className={cn("w-2.5 h-5 animate-pulse shadow-[0_0_8px_currentColor]", promptColor.replace("text-", "bg-"))} />
        </motion.p>
      )}
    </div>
  );
}
